const DOCS_URL_PREFIX = "https://images.nowpurchase.com/docs/";

export const CIN_NUMBER = "U74999WB2016PTC217195";

export const ANNUAL_RETURNS = [
  {
    year: "2024 - 2025",
    label: "View Return 24 - 25",
    href: `${DOCS_URL_PREFIX}Biz+Hero_MGT-7_FY-2024-2025.pdf`,
    id: "CompanyAnnualReturns_FY2425_ViewReturn",
  },
  {
    year: "2023 - 2024",
    label: "View Return 23 - 24",
    href: `${DOCS_URL_PREFIX}Biz+Hero_MGT-7_FY-2023-2024.pdf`,
    id: "CompanyAnnualReturns_FY2324_ViewReturn",
  },
  {
    year: "2022 - 2023",
    label: "View Return 22 - 23",
    href: `${DOCS_URL_PREFIX}Biz+Hero_MGT-7_FY-2022-2023.pdf`,
    id: "CompanyAnnualReturns_FY2223_ViewReturn",
  },
  {
    year: "2021 - 2022",
    label: "View Return 21 - 22",
    href: `${DOCS_URL_PREFIX}Biz+Hero_MGT-7_FY-2021-2022.pdf`,
    id: "CompanyAnnualReturns_FY2122_ViewReturn",
  },
  // FY 2020-21 was filed on MGT-7A (the small-company form), not MGT-7.
  {
    year: "2020 - 2021",
    label: "View Return 20 - 21",
    href: `${DOCS_URL_PREFIX}Biz+Hero_MGT-7A_FY-2020-2021.pdf`,
    id: "CompanyAnnualReturns_FY2021_ViewReturn",
  },
];
